var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99967 13.6673C10.6816 13.6673 13.6663 10.6825 13.6663 7.00065C13.6663 3.31875 10.6816 0.333984 6.99967 0.333984C3.31778 0.333984 0.333008 3.31875 0.333008 7.00065C0.333008 10.6825 3.31778 13.6673 6.99967 13.6673ZM5.92226 4.74473C5.59683 4.41929 5.06919 4.41929 4.74375 4.74473C4.41832 5.07017 4.41832 5.5978 4.74375 5.92324L5.82116 7.00065L4.74375 8.07806C4.41832 8.4035 4.41832 8.93114 4.74375 9.25657C5.06919 9.58201 5.59683 9.58201 5.92226 9.25657L6.99967 8.17916L8.07709 9.25657C8.40252 9.58201 8.93016 9.58201 9.2556 9.25657C9.58103 8.93114 9.58103 8.4035 9.2556 8.07806L8.17819 7.00065L9.2556 5.92324C9.58103 5.5978 9.58103 5.07017 9.2556 4.74473C8.93016 4.41929 8.40252 4.41929 8.07709 4.74473L6.99967 5.82214L5.92226 4.74473Z",
    fill: "#F4526B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseFilled);
export default __webpack_public_path__ + "static/media/icon-close-filled.cd2082724f1f83f5dd61b00f34dbd713.svg";
export { ForwardRef as ReactComponent };